/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit AppointmentAction/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import MockedBadge from './MockedBadge/index'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function AppointmentAction({
  children,
  viewPath = "/DesignSystem/AppointmentAction",
  onClick,
  text,
  mocked
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({})
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtColorsNeutral100 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.100'
        })
let dtSpaceXxxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxxs'
        })
  return (<React.Fragment
>
<div
  data-testid="AppointmentAction.Horizontal"
  data-view-path={viewPath}
 style={{'--mt-1-Z26Kpx7': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Horizontal}`}
>
<button
  data-testid="AppointmentAction.Horizontal:1"
  data-view-path={viewPath}
 {...isHoveredBind}
 onClick={onClick}
 style={{'--pt-2-Z26Kpx7': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pb-3-Z26Kpx7': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--bc-4-Z26Kpx7': isHovered ? dtColorsNeutral100 : dtColorsWhite}}
 className={`views-block ${styles.Horizontal1}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight={isHovered ? "semibold" : "normal"}
 text={text}
/>
</button>
<div
  data-testid="AppointmentAction.Vertical"
  data-view-path={viewPath}
 style={{'--r-5-Z26Kpx7': typeof dtSpaceXxxs === 'number' ? `${dtSpaceXxxs}px` : dtSpaceXxxs}}
 className={`views-block ${styles.Vertical}`}
>
<MockedBadge
  viewPath={`${viewPath}/MockedBadge`}
 mocked={mocked}
/>
</div>
</div>
{children}
</React.Fragment>)
}